import i18n from "../i18n";import { Trans } from "react-i18next";import React, { useState, useEffect, useMemo } from 'react';
import api from '../utils/api';
import './LoginPage.css';

function Logo() {
  return (
    <div className="lp-logo">
      {/* <div className="lp-logo-icon">K</div> */}
      <img src="/images/karya1.1.jpg"
      alt={i18n.t("common.companyLogo")}
      className="lp-logo-icon" />
      
      <div className="lp-logo-text">
        <span className="lp-logo-name"><Trans i18nKey="common.karya" /></span>
        <span className="lp-saas"><Trans i18nKey="common.saas" /></span>
      </div>
    </div>);

}

export default function LoginPage({ onLogin }) {
  const [view, setView] = useState('login'); // 'login' | 'forgot'

  // --- Sign In States ---
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');


  // --- Forgot Password Progressive States ---
  const [forgotStep, setForgotStep] = useState(1); // 1, 2, 3, 4 (Success redirect)
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotTenantId, setForgotTenantId] = useState('');
  const [otp, setOtp] = useState('');
  const [otpVerified, setOtpVerified] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [countdown, setCountdown] = useState(30);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotError, setForgotError] = useState('');
  const [forgotSuccessMsg, setForgotSuccessMsg] = useState('');

  // Inline Validation States
  const [emailError, setEmailError] = useState('');
  const [tenantError, setTenantError] = useState('');
  const [otpError, setOtpError] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');

  const OTP_LENGTH = 6;

  // Resend OTP 30s countdown timer
  useEffect(() => {
    let timer;
    if (view === 'forgot' && forgotStep === 2 && countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [view, forgotStep, countdown]);

  // Live password validation checklist
  const passChecks = useMemo(() => {
    return {
      match: confirmPassword !== '' && newPassword === confirmPassword,
      bothFilled: newPassword !== '' && confirmPassword !== ''
    };
  }, [newPassword, confirmPassword]);

  const focusOtpInput = (index = 0) => {
    setTimeout(() => {
      const input = document.getElementById(`otp-input-${index}`);
      if (input) input.focus();
    }, 100);
  };

  // OTP character block change, keydown, paste handlers (6 alphanumeric)
  const handleOtpChange = (index, value) => {
    if (otpVerified) return;
    const char = value.slice(-1);
    if (char !== '' && !/^[A-Za-z0-9]$/.test(char)) return;
    const otpArray = otp.split('');
    while (otpArray.length < OTP_LENGTH) otpArray.push('');
    otpArray[index] = char;
    const finalOtp = otpArray.join('').slice(0, OTP_LENGTH);
    setOtp(finalOtp);
    if (char !== '' && index < OTP_LENGTH - 1) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (otpVerified) return;
    if (e.key === 'Backspace') {
      const otpArray = otp.split('');
      while (otpArray.length < OTP_LENGTH) otpArray.push('');
      if (otpArray[index] === '' && index > 0) {
        otpArray[index - 1] = '';
        setOtp(otpArray.join(''));
        const prevInput = document.getElementById(`otp-input-${index - 1}`);
        if (prevInput) prevInput.focus();
      } else {
        otpArray[index] = '';
        setOtp(otpArray.join(''));
      }
    }
  };

  const handleOtpPaste = (e) => {
    if (otpVerified) return;
    const data = e.clipboardData.getData('text').trim();
    if (/^[A-Za-z0-9]{6}$/.test(data)) {
      setOtp(data);
      const lastInput = document.getElementById(`otp-input-${OTP_LENGTH - 1}`);
      if (lastInput) lastInput.focus();
    }
    e.preventDefault();
  };

  const resetForgotFormState = () => {
    setForgotStep(1);
    setForgotEmail('');
    setForgotTenantId('');
    setOtp('');
    setOtpVerified(false);
    setNewPassword('');
    setConfirmPassword('');
    setForgotError('');
    setForgotSuccessMsg('');
    setCountdown(30);
    setEmailError('');
    setTenantError('');
    setOtpError('');
    setNewPasswordError('');
    setConfirmPasswordError('');
  };

  const handleGoToLogin = () => {
    setView('login');
    resetForgotFormState();
  };

  const handleBackToForgot = () => {
    setForgotStep(1);
    setOtp('');
    setOtpVerified(false);
    setOtpError('');
    setForgotError('');
    setForgotSuccessMsg('');
  };

  const getMaskedEmail = (emailStr) => {
    if (!emailStr) return '';
    const parts = emailStr.split('@');
    if (parts.length !== 2) return emailStr;
    const name = parts[0];
    const domain = parts[1];
    if (name.length <= 2) return `${name[0]}*@${domain}`;
    return `${name.substring(0, 2)}****@${domain}`;
  };

  const handleSendOtp = async (e) => {
    if (e) e.preventDefault();
    let valid = true;

    // Email validation
    if (!forgotEmail) {
      setEmailError('Email Address is required.');
      valid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(forgotEmail)) {
        setEmailError('Please enter a valid email address.');
        valid = false;
      } else {
        setEmailError('');
      }
    }

    // Tenant ID validation
    if (!forgotTenantId) {
      setTenantError('Tenant ID is required.');
      valid = false;
    } else if (isNaN(Number(forgotTenantId))) {
      setTenantError('Tenant ID must be a valid number.');
      valid = false;
    } else {
      setTenantError('');
    }

    if (!valid) return;

    setForgotError('');
    setForgotSuccessMsg('');
    setForgotLoading(true);
    try {
      await api.forgotPasswordGetOtp(forgotEmail.trim(), Number(forgotTenantId));
      setForgotSuccessMsg('OTP has been sent to your registered email address.');
      setForgotStep(2);
      setOtpVerified(false);
      setCountdown(30);
      setOtp('');
      focusOtpInput(0);
    } catch (err) {
      setForgotError(err.message || 'Failed to send OTP.');
    } finally {
      setForgotLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setForgotError('');
    setForgotSuccessMsg('');
    setOtpError('');
    setForgotLoading(true);
    try {
      await api.forgotPasswordGetOtp(forgotEmail.trim(), Number(forgotTenantId));
      setForgotSuccessMsg('OTP has been resent to your registered email address.');
      setCountdown(30);
      setOtp('');
      setOtpVerified(false);
      focusOtpInput(0);
    } catch (err) {
      setOtpError(err.message || 'Failed to resend OTP.');
    } finally {
      setForgotLoading(false);
    }
  };

  const handleChangeEmail = () => {
    setOtp('');
    setOtpVerified(false);
    setForgotError('');
    setForgotSuccessMsg('');
    setOtpError('');
    setForgotStep(1);
  };

  const handleVerifyOtp = async (e) => {
    if (e) e.preventDefault();
    if (!otp) {
      setOtpError('OTP is required.');
      return;
    }
    if (otp.length !== OTP_LENGTH) {
      setOtpError(`OTP must be exactly ${OTP_LENGTH} characters.`);
      return;
    }
    setOtpError('');
    setForgotError('');
    setForgotSuccessMsg('');
    setForgotLoading(true);
    try {
      await api.forgotPasswordValidateOtp(
        forgotEmail.trim(),
        Number(forgotTenantId),
        otp
      );
      setOtpVerified(true);
      setForgotSuccessMsg('OTP Verified Successfully');
      setForgotStep(3);
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => {
        const newPwdInput = document.getElementById('lp-new-password');
        if (newPwdInput) newPwdInput.focus();
      }, 100);
    } catch (err) {
      setOtpError(err.message || 'Invalid OTP code.');
    } finally {
      setForgotLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    if (e) e.preventDefault();
    let valid = true;

    if (!newPassword) {
      setNewPasswordError('New Password is required.');
      valid = false;
    } else {
      setNewPasswordError('');
    }

    if (!confirmPassword) {
      setConfirmPasswordError('Confirm Password is required.');
      valid = false;
    } else if (newPassword !== confirmPassword) {
      setConfirmPasswordError('Passwords do not match.');
      valid = false;
    } else {
      setConfirmPasswordError('');
    }

    if (!valid) return;

    setForgotError('');
    setForgotSuccessMsg('');
    setForgotLoading(true);
    try {
      await api.forgotPasswordChangePwd(
        forgotEmail.trim(),
        newPassword,
        confirmPassword,
        Number(forgotTenantId)
      );
      setForgotSuccessMsg('✓ Password Reset Successfully');
      setForgotStep(4);
      setTimeout(() => {
        handleGoToLogin();
      }, 3000);
    } catch (err) {
      setForgotError(err.message || 'Failed to reset password.');
    } finally {
      setForgotLoading(false);
    }
  };

  async function handleSubmit(ev) {
    ev.preventDefault();
    if (!email || !password || !tenantId) {setError('All fields are required.');return;}
    if (isNaN(Number(tenantId))) {setError('Tenant ID must be a number.');return;}
    setError('');
    setLoading(true);
    try {
      const json = await api.login(email, password, Number(tenantId), rememberMe);
      onLogin(json.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lp-page">
      <div className="lp-left">
        <Logo />

        <div className="lp-left-content">
          <h1 className="lp-headline">
            <Trans i18nKey="auth.runYourEntire" /><br />
            <Trans i18nKey="auth.businessFromOne" /><br />
            <Trans i18nKey="auth.place" />
          </h1>

          <p className="lp-subheadline">
            <Trans i18nKey="auth.ordersInvoicesGstInventoryAndPeopleKaryaKeeps" />
          </p>
        </div>

        {/* <div className="lp-metrics">
           <div className="lp-metric-item">
             <span className="lp-metric-number">40,000+</span>
             <span className="lp-metric-label">businesses</span>
           </div>
           <div className="lp-metric-item">
             <span className="lp-metric-number">₹1,200 Cr</span>
             <span className="lp-metric-label">invoiced / month</span>
           </div>
           <div className="lp-metric-item">
             <span className="lp-metric-number">4.8★</span>
             <span className="lp-metric-label">avg. rating</span>
           </div>
          </div> */}
          </div>

      <div className="lp-right">
        {view === 'login' ?
        <div className="lp-card">
            <h2 className="lp-title"><Trans i18nKey="auth.welcomeBack" /></h2>
            <p className="lp-subtitle"><Trans i18nKey="formActions.signInToYourKaryaWorkspace" /></p>
            
            {error &&
          <div className="lp-error" role="alert">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <span>{error}</span>
              </div>
          }

            <form onSubmit={handleSubmit} noValidate>
              <div className="lp-field">
                <label htmlFor="lp-email"><Trans i18nKey="common.email" /></label>
                <div className="lp-input-container">
                  <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <input
                  id="lp-email"
                  type="email"
                  placeholder={i18n.t("auth.yourRegisteredEmailWithTenant")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  inputMode="email" />
                
                </div>
              </div>

              <div className="lp-field">
                <label htmlFor="lp-password"><Trans i18nKey="auth.password" /></label>
                <div className="lp-input-container">
                  <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                  <input
                  id="lp-password"
                  type={showPwd ? 'text' : 'password'}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password" />
                
                  <button
                  type="button"
                  className="lp-eye-btn"
                  aria-label={showPwd ? 'Hide password' : 'Show password'}
                  onClick={() => setShowPwd((s) => !s)}>
                  
                    {showPwd ?
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                          <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </svg> :
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                  }
                  </button>
                </div>
              </div>

              <div className="lp-field">
                <label htmlFor="lp-tenant"><Trans i18nKey="common.tenantId2" /></label>
                <div className="lp-input-container">
                  <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <ellipse cx="12" cy="5" rx="9" ry="3" />
                    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
                    <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
                  </svg>
                  <input
                  id="lp-tenant"
                  type="text"
                  inputMode="numeric"
                  placeholder={i18n.t("examples.eG1")}
                  value={tenantId}
                  onChange={(e) => setTenantId(e.target.value)} />
                
                </div>
              </div>

              <div className="lp-row">
                <label className="lp-remember" htmlFor="lp-remember-me">
                  <input
                  id="lp-remember-me"
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)} />
                  <Trans i18nKey="auth.rememberMe" />
                
              </label>
                <a
                href="#reset"
                className="lp-forgot-link"
                onClick={(e) => {
                  e.preventDefault();
                  setView('forgot');
                  resetForgotFormState();
                }}>
                  <Trans i18nKey="auth.forgotPassword" />
                
              </a>
              </div>

              <button type="submit" className="lp-submit" disabled={loading}>
                {loading ?
              <><span className="lp-spinner" aria-hidden="true" /> <Trans i18nKey="formActions.signingIn" /></> :

              'Sign In'
              }
              </button>
            </form>
          </div> : (

        /* Progressive Forgot Password Card Flow - Three Distinct Screens & Success State */
        <div className="lp-card">
            {forgotStep === 1 &&
          <div className="animate-fade-slide">
                <h2 className="lp-title"><Trans i18nKey="auth.forgotPassword2" /></h2>
                <p className="lp-subtitle">
                  <Trans i18nKey="auth.enterYourRegisteredEmailAddressAndTenantId" />
                </p>

                {forgotError &&
            <div className="lp-error" role="alert">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <span>{forgotError}</span>
                  </div>
            }

                <form onSubmit={handleSendOtp} noValidate>
                  <div className="lp-field">
                    <label htmlFor="lp-forgot-email"><Trans i18nKey="auth.emailAddress" /></label>
                    <div className="lp-input-container">
                      <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                      </svg>
                      <input
                    id="lp-forgot-email"
                    type="email"
                    placeholder={i18n.t("auth.yourRegisteredEmail")}
                    value={forgotEmail}
                    onChange={(e) => {setForgotEmail(e.target.value);setEmailError('');}}
                    autoComplete="email"
                    inputMode="email"
                    autoFocus
                    disabled={forgotLoading} />
                  
                    </div>
                    {emailError && <span className="lp-field-error">{emailError}</span>}
                  </div>

                  <div className="lp-field">
                    <label htmlFor="lp-forgot-tenant"><Trans i18nKey="common.tenantId" /></label>
                    <div className="lp-input-container">
                      <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <ellipse cx="12" cy="5" rx="9" ry="3" />
                        <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
                        <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" />
                      </svg>
                      <input
                    id="lp-forgot-tenant"
                    type="text"
                    inputMode="numeric"
                    placeholder={i18n.t("examples.eG1")}
                    value={forgotTenantId}
                    onChange={(e) => {setForgotTenantId(e.target.value);setTenantError('');}}
                    disabled={forgotLoading} />
                  
                    </div>
                    {tenantError && <span className="lp-field-error">{tenantError}</span>}
                  </div>

                  <div className="lp-forgot-btn-row">
                    <button type="submit" className="lp-submit" disabled={forgotLoading}>
                      {forgotLoading ?
                  <><span className="lp-spinner" aria-hidden="true" /> <Trans i18nKey="formActions.sendingOtp" /></> :

                  'Send OTP'
                  }
                    </button>

                    <button
                  type="button"
                  onClick={handleGoToLogin}
                  className="lp-submit"
                  style={{ backgroundColor: '#f1f5f9', color: '#334155', border: '1px solid #e2e8f0', marginTop: '0' }}>
                      <Trans i18nKey="formActions.backToLogin" />
                    
                </button>
                  </div>
                </form>
              </div>
          }

            {forgotStep === 2 &&
          <div className="animate-fade-slide">
                <h2 className="lp-title"><Trans i18nKey="formActions.verifyOtp" /></h2>
                <p className="lp-subtitle">
                  <Trans i18nKey="auth.weVeSentAVerificationCodeToYour" /> <strong>{getMaskedEmail(forgotEmail)}</strong>
                </p>

                {forgotError &&
            <div className="lp-error" role="alert">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <span>{forgotError}</span>
                  </div>
            }

                {forgotSuccessMsg &&
            <div className="lp-success" role="alert">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>{forgotSuccessMsg}</span>
                  </div>
            }

                <form onSubmit={handleVerifyOtp} noValidate>
                  <div className="lp-field">
                    <label><Trans i18nKey="auth.otp" /></label>
                    <div className="lp-otp-inputs">
                      {[0, 1, 2, 3, 4, 5].map((index) =>
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="text"
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck={false}
                    maxLength={1}
                    value={otp[index] || ''}
                    onChange={(e) => {handleOtpChange(index, e.target.value);setOtpError('');}}
                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    onPaste={index === 0 ? handleOtpPaste : undefined}
                    className="lp-otp-box"
                    disabled={forgotLoading || otpVerified}
                    autoComplete={index === 0 ? 'one-time-code' : 'off'}
                    autoFocus={index === 0} />

                  )}
                    </div>
                    {otpError && <span className="lp-field-error">{otpError}</span>}
                  </div>

                  <div className="lp-forgot-resend-info">
                    <div>
                      {countdown > 0 ?
                  <span style={{ color: '#94a3b8', fontSize: '13px', fontWeight: '500' }}><Trans i18nKey="auth.resendOtpIn" />{countdown}<Trans i18nKey="auth.s" /></span> :

                  <button
                    type="button"
                    onClick={handleResendOtp}
                    className="lp-forgot-resend-btn"
                    disabled={forgotLoading || otpVerified}>
                          <Trans i18nKey="auth.resendOtp" />
                        
                  </button>
                  }
                    </div>
                    <div>
                      <span
                    onClick={otpVerified ? undefined : handleChangeEmail}
                    className="lp-forgot-change-email"
                    style={{ fontSize: '13px', fontWeight: '500', ...(otpVerified ? { pointerEvents: 'none', opacity: 0.5 } : {}) }}>
                        <Trans i18nKey="formActions.changeEmail" />
                      
                  </span>
                    </div>
                  </div>

                  <div className="lp-forgot-btn-row">
                    <button
                  type="submit"
                  className="lp-submit"
                  disabled={forgotLoading || otpVerified || otp.length !== OTP_LENGTH}>
                  
                      {forgotLoading ?
                  <><span className="lp-spinner" aria-hidden="true" /> <Trans i18nKey="formActions.verifying" /></> :

                  'Verify OTP'
                  }
                    </button>

                    <button
                  type="button"
                  onClick={handleBackToForgot}
                  className="lp-submit"
                  style={{ backgroundColor: '#f1f5f9', color: '#334155', border: '1px solid #e2e8f0', marginTop: '0' }}
                  disabled={forgotLoading}>
                      <Trans i18nKey="formActions.back" />
                    
                </button>
                  </div>
                </form>
              </div>
          }

            {forgotStep === 3 &&
          <div className="animate-fade-slide">
                <h2 className="lp-title"><Trans i18nKey="formActions.resetPassword" /></h2>
                <p className="lp-subtitle">
                  <Trans i18nKey="formActions.createANewPasswordForYourAccount" />
                </p>

                {forgotError &&
            <div className="lp-error" role="alert">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <span>{forgotError}</span>
                  </div>
            }

                {forgotSuccessMsg &&
            <div className="lp-success" role="alert">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>{forgotSuccessMsg}</span>
                  </div>
            }

                <form onSubmit={handleResetPassword} noValidate>
                  <div className="lp-field">
                    <label htmlFor="lp-new-password"><Trans i18nKey="auth.newPassword" /></label>
                    <div className="lp-input-container">
                      <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                      <input
                    id="lp-new-password"
                    type={showNewPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    value={newPassword}
                    onChange={(e) => {setNewPassword(e.target.value);setNewPasswordError('');}}
                    autoComplete="new-password"
                    autoFocus />
                  
                      <button
                    type="button"
                    className="lp-eye-btn"
                    aria-label={showNewPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowNewPassword((s) => !s)}>
                    
                        {showNewPassword ?
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                            <line x1="1" y1="1" x2="23" y2="23" />
                          </svg> :

                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                    }
                      </button>
                    </div>
                    {newPasswordError && <span className="lp-field-error">{newPasswordError}</span>}
                  </div>

                  <div className="lp-field">
                    <label htmlFor="lp-confirm-password"><Trans i18nKey="auth.confirmPassword" /></label>
                    <div className="lp-input-container">
                      <svg className="lp-input-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                      <input
                    id="lp-confirm-password"
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="••••••••"
                    value={confirmPassword}
                    onChange={(e) => {setConfirmPassword(e.target.value);setConfirmPasswordError('');}}
                    autoComplete="new-password" />
                  
                      <button
                    type="button"
                    className="lp-eye-btn"
                    aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowConfirmPassword((s) => !s)}>
                    
                        {showConfirmPassword ?
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                            <line x1="1" y1="1" x2="23" y2="23" />
                          </svg> :

                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                    }
                      </button>
                    </div>
                    {confirmPasswordError && <span className="lp-field-error">{confirmPasswordError}</span>}
                  </div>

                  {/* Live Password Checklist */}
                  {/* <div className="lp-strength-checker">
                 <div className="lp-strength-title">Password Requirements:</div>
                 <div className={`lp-strength-item ${passChecks.length ? 'valid' : ''}`}>
                   <span className="lp-strength-icon">{passChecks.length ? '✓' : '•'}</span>
                   At least 8 characters
                 </div>
                 <div className={`lp-strength-item ${passChecks.uppercase ? 'valid' : ''}`}>
                   <span className="lp-strength-icon">{passChecks.uppercase ? '✓' : '•'}</span>
                   At least one uppercase letter (A-Z)
                 </div>
                 <div className={`lp-strength-item ${passChecks.lowercase ? 'valid' : ''}`}>
                   <span className="lp-strength-icon">{passChecks.lowercase ? '✓' : '•'}</span>
                   At least one lowercase letter (a-z)
                 </div>
                 <div className={`lp-strength-item ${passChecks.number ? 'valid' : ''}`}>
                   <span className="lp-strength-icon">{passChecks.number ? '✓' : '•'}</span>
                   At least one number (0-9)
                 </div>
                 <div className={`lp-strength-item ${passChecks.special ? 'valid' : ''}`}>
                   <span className="lp-strength-icon">{passChecks.special ? '✓' : '•'}</span>
                   At least one special character
                 </div>
                 <div className={`lp-strength-item ${passChecks.match ? 'valid' : ''}`}>
                   <span className="lp-strength-icon">{passChecks.match ? '✓' : '•'}</span>
                   Passwords match
                 </div>
                </div> */}

                  <div className="lp-forgot-btn-row">
                    <button
                  type="submit"
                  className="lp-submit"
                  disabled={
                  forgotLoading ||
                  !passChecks.bothFilled ||
                  !passChecks.match
                  }>
                  
                      {forgotLoading ?
                  <><span className="lp-spinner" aria-hidden="true" /> <Trans i18nKey="formActions.resettingPassword" /></> :

                  'Reset Password'
                  }
                    </button>
                  </div>
                </form>
              </div>
          }

            {forgotStep === 4 &&
          <div className="animate-fade-slide text-center py-6">
                <div className="flex justify-center mb-5" style={{ display: 'flex', justifyContent: 'center' }}>
                  <div className="h-16 w-16 bg-emerald-50 rounded-full flex items-center justify-center border border-emerald-200 text-emerald-600" style={{ width: '64px', height: '64px', borderRadius: '50%', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#166534' }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                </div>
                <h2 className="lp-title"><Trans i18nKey="auth.passwordResetSuccessfully" /></h2>
                <p className="lp-subtitle mt-2">
                  <Trans i18nKey="dateTime.yourPasswordHasBeenUpdatedSuccessfullyYouCan" />
                </p>
                <div className="lp-forgot-btn-row">
                  <button
                type="button"
                onClick={handleGoToLogin}
                className="lp-submit">
                    <Trans i18nKey="auth.goToLogin" />
                  
              </button>
                </div>
              </div>
          }
          </div>)
        }
      </div>
    </div>);

}
